import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { AgGridFilterOption } from 'core/enums';
import { formatDate, formatQuantity } from 'core/utils';

export const columnDef = (): ColDef[] => [
  {
    colId: 'soNumber',
    headerName: t('headerSalesOrder'),
    field: 'soNumber',
    flex: 1,
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'expectedShipDate',
    headerName: t('headerExpectedShipmentDate'),
    field: 'expectedShipDate',
    flex: 1,
    filter: 'agDateColumnFilter',
    filterParams: {
      defaultOption: AgGridFilterOption.GREATER_THAN,
    },
    valueFormatter: ({ value }) => formatDate(value),
  },
  {
    colId: 'quantity',
    headerName: t('headerQty'),
    field: 'quantity',
    flex: 1,
    filter: 'agNumberColumnFilter',
    filterParams: {
      defaultOption: AgGridFilterOption.GREATER_THAN_OR_EQUAL,
    },
    valueGetter: ({ data }) => data && formatQuantity(data.quantity),
  },
];
